// Sets the button to disabled if there is no possibility for a jump in the history
const linkBackButton = document.querySelector('.hero-link-back-block button');
if (linkBackButton) {
  if (history.length <= 1 && document.referrer) {
    linkBackButton.disabled = true;
  } else {
    linkBackButton.addEventListener('click', ev => {
      ev.preventDefault();
      history.back();
    });
  }
}
